import React from 'react';

const ComingSoon = (props) => {
     
    return (
        <>
            {                
                <section>
                    <header>
                        <span>Coming soon.....</span>
                    </header>
                    <div ></div>   
                </section>
            }
            
        </>
    )    
}

export default ComingSoon;


